type Props = {
    title: string;
    value: number;
    icon: string;
};

const KpiCard = ({ title, value, icon }: Props) => {
    return (
        <div className="bg-white rounded-2xl p-5 shadow-sm hover:shadow-md transition">
            <div className="flex justify-between">
                <span className="text-gray-500 text-sm">{title}</span>
                <span className="text-xl">{icon}</span>
            </div>

            <h2 className="text-2xl font-bold mt-2">
                QAR {value.toLocaleString()}
            </h2>
        </div>
    );
};

export default KpiCard;